export default (editor, opts = {}) => {
    const DOMC = editor.DomComponents;
    const TYPE = DOMC.getType('text');
    const MODEL = TYPE.model;
    const VIEW = TYPE.view;
    const BM = editor.BlockManager;
    const TYPE_NAME = "invalid-feedback";


    DOMC.addType(TYPE_NAME, {
        extend: 'text',
        isComponent(el) {
            let match = false;
            if (el && el.classList) {
                el.classList.forEach(function (klass) {
                    if (klass.match(/^invalid-feedback/)) {
                        match = true;
                    }
                });
            }
            if (match) return { type: TYPE_NAME };
        },
        model: {
            defaults: {
                ...MODEL.prototype.defaults,
                'custom-name': 'Invalid Feedback',
                // draggable: "[data-gjs-type=C-FORM-SWIPER],[data-gjs-type=form]",
                droppable: false,
                classes: ['invalid-feedback'],
                content: "Something is wrong"
            },

        }

    });

    BM.add(TYPE_NAME, {
        label: "Invalid Feedback",
        content: {
            type: TYPE_NAME,
        },
        category: "Forms",
    });
};
